(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-verification"] && !Shopify.designMode) return;
  try {
    const showPopup = (background, content) => {
    background.style.display = 'block'
    background.classList.add('age-cta')
    content.style.display = 'block'
}
const hidePopup = (background, content) => {
    background.classList.add('fade-out')
    setTimeout(() => {
        background.classList.remove('age-cta')
        background.style.display = 'none'
        content.style.display = 'none'
    }, 400);
}

const checkCookie = () => {
    const agePopup = document.getElementById("prompt-background");
    const ageContent = document.getElementById("age-check-prompt");

    if (!agePopup) return
    if (window.location.hostname != 'junospirits.com') {
        hidePopup(agePopup, ageContent)
        return
    }
    const readCookie = (name) => {
        const nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    };
    
    const isAnAdult = readCookie('age_verification');
    if (isAnAdult) {
        hidePopup(agePopup, ageContent)
        return true
    } else {
        showPopup(agePopup, ageContent)
        return false
    }
}
checkCookie()

const agePopup = document.getElementById("prompt-background");
const ageContent = document.getElementById("age-check-prompt");
document.addEventListener("DOMContentLoaded", () => {
    const isAgeVerified = checkCookie()

    const isLegalButton = document.getElementById("is-legal-age");
    function isLegalAge() {
        document.cookie = "age_verification=true; path=/; SameSite=Lax; Secure"
        hidePopup(agePopup, ageContent)
    };
    if (isLegalButton) {
        isLegalButton.addEventListener("click", (event) => {
            event.preventDefault();
            isLegalAge()
        });
    }

    const notLegalButton = document.getElementById("not-legal-age");
    function notLegalAge() {
        window.location = 'https://www.aucklandzoo.co.nz/animals/archeys-frog';
    }
    if (notLegalButton) {
        notLegalButton.addEventListener("click", (event) => {
            event.preventDefault();
            notLegalAge()
        });
    }
    
    // document.readyState === 'complete' ? hidePopup(agePopup, ageContent) : window.addEventListener('load', hidePopup(agePopup, ageContent))
    window.addEventListener('pageshow', (event) => { if (event.persisted) { hidePopup(agePopup, ageContent) } })

    const links = document.querySelectorAll('a');
  
    links.forEach(link => {
        link.addEventListener('click', function(e) {
            const url = this.href
            const target = this.target
            const parentID = typeof this.parentElement.id == 'string' ? this.parentElement.id : ''
            console.log(link.type)
            
            if (
                this.hostname !== window.location.hostname ||
                !url || 
                url.startsWith('#') || 
                url.startsWith('javascript:') || 
                url.startsWith('tel:') || 
                url.startsWith('mailto:') || 
                target === '_blank' ||  
                url.includes('#') || 
                e.metaKey || 
                e.shiftKey || 
                e.ctrlKey ||
                parentID.toLowerCase().includes('remove')
            ) return;
            e.preventDefault();

            const transition = document.getElementById("prompt-background")
            transition.style.display = 'block'
            transition.classList.remove('fade-out')
            transition.classList.add('fade-in')
            
            const destination = this.href;
            setTimeout(() => {
                window.location.href = destination;
            }, 200); 
        });
    });
})
  } catch(e) { console.error(e); }
})();

})();
